<template>
  <div class="evento-container">
    <!-- ENCABEZADO -->
    <div class="encabezado-ubicacion">
      <div class="ornamento ornamento-left" />
      <div class="ubicacion-linea">
        <div
          ref="lineaDecorativa"
          class="linea-decorativa"
        />
      </div>
    </div>

    <!-- CEREMONIA -->
    <div class="evento-card">
      <div class="icono-evento">
        <img
          src="@/assets/iglesiapng.png"
          alt="Ícono ceremonia"
        >
      </div>
      <p class="evento-tipo">
        Ceremonia
      </p>
      <div
        ref="imgCeremonia"
        class="evento-imagen-wrapper"
      >
         <video
            class="imagen-fondo"
            autoplay
            muted
            loop
            playsinline
          >
            <source :src="videoWebm" type="video/webm" />
            <source :src="videoMp4" type="video/mp4" />
            Tu navegador no soporta videos HTML5.
          </video>
        <img
          src="@/assets/marco.png"
          class="marco-decorativo"
        >
      </div>
      <div
        ref="infoCeremonia"
        class="evento-info"
      >
        <p class="evento-lugar">
Hotel Gran Palacio        </p>
        <p class="evento-direccion">
        Francisco I. Madero No. 106D, Zona Centro  <br> Cd. Victoria, Tamaulipas. 
        </p>
        <p class="hora">
          6:00 PM
        </p>
        <a
          href="https://maps.app.goo.gl/ptEfiQXFvKdB77w79"
          class="btn-mapa"
          target="_blank"
        >¿Cómo llegar?</a>
      </div>

      <!-- LÍNEA ANIMADA CONECTOR -->
      <div
        ref="lineaCentralRef"
        class="linea-central"
      />

      <!-- RECEPCIÓN -->
      <div class="evento-card">
        <div class="icono-evento">
          <img
            src="@/assets/celebracionpng.png"
            alt="Ícono recepción"
          >
        </div>
        <p class="evento-tipo">
          Recepción
        </p>
        <div
          ref="imgRecepcion"
          class="evento-imagen-wrapper"
        >
          <img
            src="@/assets/salon.jpg"
            class="imagen-fondo"
          >
          <img
            src="@/assets/marco.png"
            class="marco-decorativo"
          >
        </div>
        <div
          ref="infoRecepcion"
          class="evento-info"
        >
          <p class="evento-lugar">
           Casa Paraiso
          </p>
          <p class="evento-direccion">
           Benito Juarez No. 34, Zona Centro <br> Cd. Victoria, Tamaulipas. 
          </p>
          <p class="hora">
            8:00 PM
          </p>
          <a
            href="https://maps.app.goo.gl/7LS3kEXsgTmcoPan8"
            class="btn-mapa"
            target="_blank"
          >¿Cómo llegar?</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import { gsap } from 'gsap'
import videoMp4 from '@/assets/civil.mp4'
import videoWebm from '@/assets/civil.webm'
export default {
  name: 'EventoSection',
  setup() {
    const infoCeremonia = ref(null)
    const infoRecepcion = ref(null)
    const lineaCentralRef = ref(null)
    const lineaDecorativa = ref(null)
    const imgCeremonia = ref(null)
    const imgRecepcion = ref(null)

    const animarElemento = (element) => {
      gsap.fromTo(
        element,
        { opacity: 0, y: 60 },
        { opacity: 1, y: 0, duration: 1.5, ease: 'power2.out' }
      )
    }

    const animarLinea = (element) => {
      gsap.fromTo(
        element,
        { scaleY: 0 },
        { scaleY: 1, transformOrigin: 'top center', duration: 1.2, ease: 'power2.out' }
      )
    }

    onMounted(() => {
      const observar = (el, accion) => {
        const observer = new IntersectionObserver((entries, obs) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              accion()
              obs.unobserve(entry.target)
            }
          })
        }, { threshold: 0.4 })
        observer.observe(el.value)
      }

      observar(imgCeremonia, () => animarElemento(imgCeremonia.value))
      observar(infoCeremonia, () => animarElemento(infoCeremonia.value))
      observar(imgRecepcion, () => animarElemento(imgRecepcion.value))
      observar(infoRecepcion, () => animarElemento(infoRecepcion.value))
      observar(lineaDecorativa, () => animarLinea(lineaDecorativa.value))
      observar(lineaCentralRef, () => animarLinea(lineaCentralRef.value))
    })

    return {
      infoCeremonia,
      infoRecepcion,
      lineaCentralRef,
      lineaDecorativa,
      imgCeremonia,
      imgRecepcion,
        videoMp4,
      videoWebm
    }
  }
}
</script>

<style scoped>
.evento-container {


  color: #fff;
  margin-top: -20px;
  margin-bottom: -20px;
  background-size: cover;
  background-position: center;
  padding-bottom: 40px;
}

.encabezado-ubicacion {
  text-align: center;
  margin-bottom: 16px;
}

.linea-decorativa {
  width: 40px;
  height: 1px;
  background-color: #413d3d;
  margin: 8px auto;
  transform: scaleX(0);
}

.evento-card {
  max-width: 400px;
  margin: 0 auto 40px;
  text-align: center;
  padding: 0px 0;
  border-radius: 12px;
  overflow: hidden;
}

.icono-evento {
  margin-top: 20px;
}

.icono-evento img {
  width: 100px;
  height: auto;
  display: inline-block;
  filter: drop-shadow(0 4px 6px rgba(0, 0, 0, 0.2));
}

.evento-imagen-wrapper {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 0;
  filter: drop-shadow(0 6px 10px rgba(0, 0, 0, 0.25));
}

.imagen-fondo {
  width: 80%;
  max-height: 200px;
  object-fit: cover;
  display: block;
  border-radius: 2px;
  box-shadow: 0 10px 25px rgba(237, 233, 233, 0.016);
  position: relative;
  z-index: 1;
  margin: 0 auto;
}

.evento-imagen-wrapper::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 10%;
  width: 80%;
  height: 30%;
  background: linear-gradient(to top, rgba(255, 255, 255, 0), transparent);
  pointer-events: none;
  z-index: 0;
  border-radius: 2px;
}

.marco-decorativo {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  pointer-events: none;
  mix-blend-mode: lighten;
    filter: brightness(0) invert(0); /* ← Esto lo hace negro */


  opacity: 0;
}

.evento-info {
  padding: 16px;
  color: #454141d9;
  opacity: 0;
}

.hora {
  font-family: 'fa';
  font-size: 15px;
  margin-bottom: 4px;
  color: #282626;
}

.evento-tipo {
  font-family: "say2";
  font-size: 34px;
  margin-bottom: 12px;
  color: #434040;
}

.evento-lugar {
  font-size: 20px  !important;
  font-family: 'padres', serif;

  font-weight: bold;
  margin-bottom: 5px;
}

.evento-direccion {
  font-family: 'padres';
  font-size: 12px;
  line-height: 1.4;
  font-weight: 800;
  color: #1b1a1ac6;
}

.btn-mapa {
  margin-top: 10px;
  background: #111111; /* negro elegante */
  color: #ffffff;
  font-size: 14px;
  padding: 8px 20px;
  text-decoration: none;
  font-family: 'padres';
  border-radius: 0px; /* cuadrado */
  font-weight: 700;
  display: inline-block;
  transition: background 0.3s ease, transform 0.3s ease;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}

.btn-mapa:hover {
  background: #000000;
  transform: scale(1.03);
}



.linea-central {
  width: 2px;
  height: 60px;
  margin: 20px auto;
  background-color: #ffffff;
  transform: scaleY(0);
}
</style>